import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const router = new Router({
  routes: [
    { path: '*', redirect: '/home' },
    {
      path: '/',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        { path: '/',          redirect: '/home' },
        { path: '/home',          name: 'home',          component: resolve => require(['@/view/HomePage'], resolve),          meta: { title: '首页' } },
        { path: '/newsinformation', name: 'newsinformation', component: resolve => require(['@/view/NewsInformation'], resolve), meta: { title: '发展历程' } },
        { path: '/service',       name: 'service',       component: resolve => require(['@/view/Service'], resolve),           meta: { title: '文达智堂' } },
        { path: '/companyintroduction', name: 'companyintroduction', component: resolve => require(['@/view/CompanyIntroduction'], resolve), meta: { title: '公司介绍' } },
        { path: '/jobchance',     name: 'jobchance',     component: resolve => require(['@/view/JobChance'], resolve),         meta: { title: '工作机会' } },
        { path: '/contactus',     name: 'contactus',     component: resolve => require(['@/view/ContactUs'], resolve),         meta: { title: '联系我们' } },
        { path: '/privacy',       name: 'privacy',       component: resolve => require(['@/view/Privacy'], resolve),            meta: { title: '隐私政策' } },
        { path: '/terms',         name: 'terms',         component: resolve => require(['@/view/Terms'], resolve),              meta: { title: '服务条款' } },
        {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: { title: '服务类目' },
          children: [
            { path: '',              redirect: 'activity' },
            { path: 'activity',     name: 'activity',     component: resolve => require(['@/view/Service_Activity'], resolve),     meta: { title: '企业活动策划' } },
            { path: 'empower',      name: 'empower',      component: resolve => require(['@/view/Service_Empower'], resolve),      meta: { title: '企业成长赋能' } },
            { path: 'video',        name: 'video',        component: resolve => require(['@/view/Service_Video'], resolve),        meta: { title: '企业影像服务' } },
            { path: 'exhibition',   name: 'exhibition',   component: resolve => require(['@/view/Service_Exhibition'], resolve),   meta: { title: '企业数字展厅' } },
            { path: 'procurement',  name: 'procurement',  component: resolve => require(['@/view/Service_Procurement'], resolve),  meta: { title: '集采供应链' } },
            { path: 'visual',       name: 'visual',       component: resolve => require(['@/view/Service_Visual'], resolve),       meta: { title: '企业视觉阵地' } }
          ]
        },
        { path: '/admin', name: 'admin', component: resolve => require(['@/view/Admin'], resolve), meta: { title: '管理后台' } }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) document.title = to.meta.title
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js